import { ThemeProvider } from '@mui/material';
import { DEFAULT_CURRENCY } from '@weft/types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { muiDefaultTheme } from '../../../assets/themes/default-theme';
import { vyTheme } from '../../../assets/themes/vy-theme';
import { withPageLayout } from '../../../components/new-design/layout/VyPageLayout';
import { FormErrorNotificationProvider } from '../../../contexts/form-error-notification-context/FormErrorNotificationProvider';
import { CreateInvoiceErrorNotification } from './create-invoice-page-components/CreateInvoiceErrorNotification/CreateInvoiceErrorNotification';
import { withCreateInvoiceForm } from './create-invoice-page-components/CreateInvoiceForm/CreateInvoiceForm';
import { CreateInvoicePageContent } from './create-invoice-page-components/CreateInvoicePageContent';
import { CreateInvoicePageStepperNavigator } from './create-invoice-page-components/CreateInvoicePageStepperNavigator';
import { CreateInvoiceStepper } from './create-invoice-page-components/CreateInvoiceStepper/CreateInvoiceStepper';
import { INVOICE_CREATION_STEPS } from './create-invoice-page-contexts/create-invoice-context/create-invoice-context-types/invoice-creation-step';
import { CreateInvoiceProvider } from './create-invoice-page-contexts/create-invoice-context/CreateInvoiceProvider';

const CreateInvoicePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Create Invoice</title>
      </Helmet>

      <CreateInvoiceProvider defaultInvoiceCreationStep={INVOICE_CREATION_STEPS.settings}>
        <FormErrorNotificationProvider>
          <div className="flex h-full flex-col">

            <ThemeProvider theme={vyTheme}>
              <CreateInvoiceStepper currency={DEFAULT_CURRENCY}/>
            </ThemeProvider>

            <ThemeProvider theme={muiDefaultTheme}>
              <CreateInvoicePageContent/>
            </ThemeProvider>

            <ThemeProvider theme={vyTheme}>
              <CreateInvoicePageStepperNavigator/>
            </ThemeProvider>
            
            <CreateInvoiceErrorNotification/>

          </div>
        </FormErrorNotificationProvider>
      </CreateInvoiceProvider>
    </>
  );
};

const CreateInvoicePageWithPageLayout = withPageLayout(withCreateInvoiceForm(CreateInvoicePage), {
  path: ['Invoices', 'Create'],
  title: 'Create Invoice',
  sx: {
    padding: '0',
  },
});

export { CreateInvoicePageWithPageLayout as CreateInvoicePage };